<template>
  <!-- 网站banner轮播 -->
  <div class="website-banner">
    <div class="website-banner_div">
      <div style="width:100%;margin:0 auto;height:580px">
        <!-- Using the slider component -->
        <slider ref="banner-slider" :options="bannerOptions">
          <!-- slideritem wrapped package with the components you need -->
          <slideritem v-for="(item,index) in someList1" :key="index">
            <img :src="item.thumb" class="website-banner_img" v-bind:alt="item.name" @click="detail(item.url)">
            <div></div>
          </slideritem>
          <!-- Customizable loading -->
          <!-- <div slot="loading">loading...</div> -->
        </slider>
      </div>
    </div>
  </div>
</template>
<script>
  // import slider components
  import {
    slider,
    slideritem
  } from 'vue-concise-slider'
  export default {
    name: 'banners',
    data() {
      return {
        someList1: [],
        bannerOptions: {
          pagination: true,
          autoplay: 5000,
          thresholdDistance: 100, // Sliding distance threshold
          thresholdTime: 300, // Sliding time threshold decision
          grabCursor: true, // Scratch style
          speed: 300 // Sliding speed
        }
      }
    },
    created() {
      this.getBannerApi()
      // 声明
      this.notice()
    },
    methods: {
      notice() {
        var notifyOpen = localStorage.getItem("notifyOpen");
        if (notifyOpen != 'true') {
          this.$alert('<img src="https://file.meikesheji.com/main/notice.jpg" width="100%" />', '　', {
            dangerouslyUseHTMLString: true,
            showConfirmButton: false,
            roundButton: true,
            customClass: 'notifyOpen'
          });
          localStorage.setItem("notifyOpen", true);
        }
      },
      getBannerApi() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/index/banner', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          }
        }).then(res => {
          this.someList1 = res.data.data
          // console.log(this.someList1)
        }).catch(err => {
          console.log(err)
        })
      },
      detail(url) {
        if (url.indexOf('http') != -1) {
          window.location.href = url
        }
      }
    },
    components: {
      slider,
      slideritem
    }
  }
</script>
<style lang="scss" scoped>
  /********** 网站banner轮播 **********/
  .website-banner {
    background-color: rgb(255, 255, 255);
    width: 100%;
    height: auto;
  }

  .website-banner_div {
    height: 100%;
  }

  .website-banner_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
<style>
  .notifyOpen {
    width: 668px !important;
    background: #0845B9;
  }

  .el-message-box__content {
    padding: 0 !important;
  }

  .el-message-box__header {
    width: 628px !important;
    position: absolute !important;
    z-index: 999;
  }

  .el-icon-close {
    color: white !important;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/Homes/banners.vue